
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/instagram-feed",
      function () {
        return require("private-next-pages/design-system/instagram-feed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/instagram-feed"])
      });
    }
  